import name from './name'
import api from './api'

export { name, api }
